import type { TextQuestion } from '@shared/domain/form';
import type { LegalReview } from '@shared/domain/review';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { QuestionType, QuestionValidationRules } from '@shared/domain/form';
import { ReviewStep } from '@shared/domain/review';
import { LEGAL_FORM_FIELDS } from '../../data';
import { BaseReviewForm } from '../BaseReviewForm';

interface LegalReviewProps {
  submitReviewForm?: (
    formFields: LegalReview,
    reviewStep: ReviewStep,
    isDraft?: boolean,
  ) => void;
  editMode?: boolean;
  defaultValues?: Partial<LegalReview> & { id?: number };
  handleEditSuccess?: () => void;
}

function LegalReviewForm(props: LegalReviewProps) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const showAiQuestion = searchParams.get('showAiQuestion') === 'true';
  const formFieldsConfig = showAiQuestion
    ? [
        ...LEGAL_FORM_FIELDS,
        {
          name: 'aiInvolvementComment',
          type: QuestionType.TEXT,
          validationRules: [QuestionValidationRules.REQUIRED],
          question:
            'Please share any legal concerns over the use of AI and how you addressed this.',
        } as TextQuestion,
      ]
    : LEGAL_FORM_FIELDS;

  return (
    <BaseReviewForm<LegalReview>
      reviewStep={ReviewStep.LEGAL}
      formFields={formFieldsConfig}
      containerTestId="legal-review-step-content-anchor"
      submitButtonText="Continue to Negotiation"
      editMode={props.editMode}
      defaultValues={props.defaultValues}
      onSubmit={props.submitReviewForm}
      onEditSuccess={props.handleEditSuccess}
    />
  );
}

export default LegalReviewForm;
